import { render, staticRenderFns } from "./CDocumentRow.vue?vue&type=template&id=6bf76c21&scoped=true&"
import script from "./CDocumentRow.vue?vue&type=script&lang=js&"
export * from "./CDocumentRow.vue?vue&type=script&lang=js&"
import style0 from "./CDocumentRow.vue?vue&type=style&index=0&id=6bf76c21&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf76c21",
  null
  
)

export default component.exports